module.exports = __webpack_public_path__ + "assets/bell-small-inactive.2fcb55d0.svg";